import React from 'react';
const ITEMS = ['Licensed & Insured', 'Interior Remodeling', 'Exterior Improvements', 'Kitchens & Baths', 'Cabinetry & Built-Ins', 'Flooring', 'Painting', 'Custom Projects'];
export function MarqueeStrip() {
  return <section aria-label="What Taylor Company offers" className="w-full overflow-hidden border-y border-pine-900/10 bg-bone-100 py-5" data-id="element-135" data-mp="12638f7mofd0a">
      <div className="flex w-max animate-[marquee_38s_linear_infinite] items-center gap-14 pl-14" data-id="element-136" data-mp="9he1ut2uqfh5">
        {[...ITEMS, ...ITEMS].map((item, i) => <div key={`${item}-${i}`} className="flex items-center gap-14" data-id="element-137" data-mp="5i59nsngmpnp" data-mpi={i}>
            <span className="whitespace-nowrap text-[11px] uppercase tracking-widest2 text-pine-800/70" data-id="element-138" data-mp="jh50n6yg3gn1">
              {item}
            </span>
            <span className="h-1 w-1 rounded-full bg-pine-800/30" aria-hidden="true" data-id="element-139" data-mp="ejd582yldce3" />
          </div>)}
      </div>
      <style data-id="element-140" data-mp="1pve2655m074x">{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}